<template>
  <div class="Page Forgot">
    <div class="Forgot__box box">
      <h2 class="subtitle">Mot de passe oublié</h2>
      <hr />
      <div class="field" v-if="step === $options.STEPS.NEEDS_EMAIL">
        <label class="label">E-mail :</label>
        <input
          v-model="email"
          class="input"
          type="email"
          placeholder="john@doe.com"
        />
      </div>
      <div class="field" v-if="step === $options.STEPS.NEEDS_CODE">
        <div class="control">
          <label class="label">Code de remise à zéro :</label>
          <input
            v-model="code"
            class="input"
            type="text"
            placeholder="xxxxxxxxxxxxxxxxxxxxxx"
          />
        </div>
        <div class="control">
          <label class="label">Mot de passe souhaité :</label>
          <input
            v-model="password"
            class="input"
            type="text"
            placeholder="xxxxxxxxxxxxxxxxxxxxxx"
          />
        </div>
      </div>
      <div class="message is-success" v-if="step === $options.STEPS.SUCCESS">
        Mot de passe réinitialisé avec succès.
        <router-link :to="'/auth/login'">Me connecter</router-link>
      </div>
      <div class="message is-danger" v-if="step === $options.STEPS.FAILURE">
        Échec de la réinitialisation de votre mot de passe.
      </div>
      <div
        class="control"
        v-if="
          step === $options.STEPS.NEEDS_EMAIL ||
            step === $options.STEPS.NEEDS_CODE
        "
      >
        <button :class="submitClasses" class="button" @click="submit">
          Envoyer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { types as authTypes } from "../../store/actions/auth";

const STEPS = {
  NEEDS_EMAIL: "NEEDS_EMAIL",
  NEEDS_CODE: "NEEDS_CODE",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE"
};

export default {
  name: "Forgot",
  STEPS,
  data() {
    return {
      loading: false,
      step: STEPS.NEEDS_EMAIL,
      email: "",
      code: "",
      password: ""
    };
  },
  computed: {
    submitClasses() {
      return [this.loading ? "is-loading" : ""];
    }
  },
  methods: {
    submit() {
      switch (this.step) {
        case STEPS.NEEDS_EMAIL:
          this.$store
            .dispatch(authTypes.FORGOT, { email: this.email })
            .then(() => {
              this.step = STEPS.NEEDS_CODE;
            });
          break;
        case STEPS.NEEDS_CODE:
          this.$store
            .dispatch(authTypes.RESET, {
              email: this.email,
              code: this.code,
              password: this.password
            })
            .then(() => {
              this.step = STEPS.SUCCESS;
            })
            .catch(() => {
              this.step = STEPS.FAILURE;
            });
          break;
        default:
          break;
      }
    }
  },
  created() {
    this.step = STEPS.NEEDS_EMAIL;
    this.email = "";
    this.code = "";
    this.password = "";
  }
};
</script>

<style lang="scss">
.Page.Forgot {
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .box {
    width: 100%;
    max-width: 360px;
  }
}
</style>
